/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { NumericFormat } from 'react-number-format'
import { useNewBudget } from './NewBudget.hook'
import { useBudgetAnchorSubtitle } from './BudgetAnchorNote'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import './NewBudget.scss'
import { Helmet } from 'react-helmet'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import { useLocation } from 'react-router-dom'
import { QuizType } from 'src/pages/shared'

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props: any, ref: any) {
  const { onChange, floatingLabel, ...other } = props

  return (
    <div className="numeric-format">
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          })
        }}
        thousandSeparator
        isNumericString
        prefix="$"
        suffix={props.value >= 7500 ? '+' : ''}
      />
      {floatingLabel && <span className="floating-label">{floatingLabel}</span>}
    </div>
  )
})

export const NewBudget = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const {
    nextDisabled,
    handleNext,
    handleBack,
    budgetSelected,
    setBudgetSelected,
    imgData,
    guestCountBucket,
  } = useNewBudget(query.get('quizType') as QuizType)
  const anchorSubtitle = useBudgetAnchorSubtitle(guestCountBucket)

  const handleSliderChange = (sliderBudget: number) => {
    setBudgetSelected(sliderBudget)
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBudgetSelected(event.target.value === '' ? 0 : Number(event.target.value))
  }

  const handleBlur = () => {
    if (+budgetSelected < 1750) {
      setBudgetSelected(1750)
    } else if (+budgetSelected > 7500) {
      setBudgetSelected(7500)
    }
  }

  return (
    <>
      <Helmet>
        <script>
          {`
            function gtag_report_conversion(params){
              gtag('event', 'conversion', params);
              return false;
            }
          `}
        </script>
      </Helmet>
      <QuizQuestionWrapper
        showBgFlower={false}
        titleStep="YOUR BUDGET"
        title={
          isPinterestFlow ? (
            'How much are you budgeting for your wedding flowers?'
          ) : (
            <>
              What’s your <i>budget?</i>
            </>
          )
        }
        subtitle={anchorSubtitle}
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        step={6}
        total={7}
        customCss={{
          content: 'budget-wrapper',
        }}
        className={isPinterestFlow ? 'pinterest-flow budget' : ''}
        quizType={query.get('quizType') as QuizType}
      >
        <div className="budget-section">
          <div className="quiz-budget">
            <div className="guests-wrapper text-transform-upper range-slider-option">
              <div className="img-wrapper">
                {imgData && imgData.image && (
                  <div className="slider-image">
                    <img src={imgData.image} alt={imgData.label}></img>
                  </div>
                )}
              </div>
              <div className="quiz-budget-option-wrapper">
                <div className={`quiz-budget-slider ${isPinterestFlow ? '' : 'mt-24px'}`}>
                  <NumberFormatCustom
                    thousandSeparator={true}
                    value={budgetSelected}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    name="budgetNumber"
                    className="budget-input"
                    floatingLabel={isPinterestFlow ? 'Budget' : ''}
                  />
                  <div className="budget-slider mt-22px">
                    <Slider value={+budgetSelected} step={250} min={1750} max={7500} onChange={handleSliderChange} />
                  </div>
                </div>
              </div>
            </div>
            <div className={`action-box-wrapper ${isPinterestFlow ? 'mt-34px' : 'mt-24px'} mb-30px pb-70px`}>
              <button disabled={nextDisabled} className="button white-space-wrap" onClick={handleNext}>
                {isPinterestFlow ? 'Set Budget' : 'Continue'}
              </button>
            </div>
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
